import { render } from "./info-modal.vue?vue&type=template&id=3a928179"
import script from "./info-modal.vue?vue&type=script&lang=js"
export * from "./info-modal.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/appointments/partials/info-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a928179"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a928179', __exports__)) {
    console.log('reload')
    api.reload('3a928179', __exports__)
  }
  
  module.hot.accept("./info-modal.vue?vue&type=template&id=3a928179", () => {
    console.log('re-render')
    api.rerender('3a928179', render)
  })

}


export default __exports__